import React from 'react'

function ConditionsForContributorsEN() {
  return (
    <>
      <p className="heading-1">
        General Terms and Conditions of Use (T&Cs) Skeepers Influence
      </p>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">1. Purpose</p>
        <p>
          These general terms and conditions of use (the 'T&Cs') are intended to
          govern the use of the{' '}
          <a
            href="http://app.im.skeepers.io/"
            target="_blank"
            rel="noopener noreferrer"
          >
            http://app.im.skeepers.io/
          </a>{' '}
          site published by Skeepers, as well as the terms and conditions under
          which the various services offered on this site are provided.
          Navigating on the Site as defined below automatically implies express
          and unreserved acceptance by the Creator of these T&Cs.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">2. Definitions</p>
        <p>
          The following terms used with a capital letter have the definition
          assigned to them below:
        </p>
        <div className="definition">
          <p>T&Cs</p>
          <p>Refers to these general terms and conditions of use;</p>
        </div>
        <div className="definition">
          <p>Customer </p>
          <p>
            Refers to the company, manufacturer or entity marketing the
            product/service under a brand, subject of the Content;
          </p>
        </div>
        <div className="definition">
          <p>Content</p>
          <p>
            Refers to texts, including reviews, images, sounds, videos,
            photographs, drawings, avatars, and more generally any visual,
            textual or graphic post representing or referring to the products
            and/or services, distributed by a Creator as part of the Solution.
          </p>
        </div>
        <div className="definition">
          <p>Creator</p>
          <p>
            Person previously registered and accessing the Skeepers platform for
            the purpose of generating Content. (IM and CV).
          </p>
        </div>
        <div className="definition">
          <p>Skeepers</p>
          <p>
            Refers to the legal entity identified in the Legal Notices of the
            Site;
          </p>
        </div>
        <div className="definition">
          <p>Identifiers</p>
          <p>
            Refers to the Creator name and password allowing the Creator to
            access the Site;
          </p>
        </div>
        <div className="definition">
          <p>Products</p>
          <p>Refers to the products and services marketed by the Customer; </p>
        </div>
        <div className="definition">
          <p>Profile</p>
          <p>Refers to the interface on the Site dedicated to the Creator</p>
        </div>
        <div className="definition">
          <p>Social Networks</p>
          <p>
            Refers to all present or future social networks whose Content may be
            the subject of the Skeepers Services, such as, for example: YouTube,
            Instagram, Facebook, Twitter, Twitch, Blogs, TikTok, Pinterest.
          </p>
        </div>
        <div className="definition">
          <p>Site</p>
          <p>
            Refers to the website accessible at the address{' '}
            <a
              href="http://app.im.skeepers.io/"
              target="_blank"
              rel="noopener noreferrer"
            >
              http://app.im.skeepers.io/
            </a>{' '}
            ;
          </p>
        </div>
        <div className="definition">
          <p>Services</p>
          <p>Refers to the services provided by Skeepers;</p>
        </div>
        <div className="definition">
          <p>Skeepers</p>
          <p>
            Désigne l’entité juridique identifiée dans les Mentions Légales du
            Site ;
          </p>
        </div>
        <div className="definition">
          <p>Tester</p>
          <p>
            Creator who has received a product for free in order for them to
            create a video (CV) or text (IM) review, which will be published on
            the e-commerce site of the Customer and/or its partners.
          </p>
        </div>
        <div className="definition">
          <p>Influencer </p>
          <p>
            Creator who has received a product for free in order for them to
            post dedicated Content on their social network (e.g., Instagram,
            TikTok, YouTube, Pinterest, Blog, etc.).Creator
          </p>
        </div>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">3. Description of Services</p>
        <p>Skeepers offers Creators the following Services: </p>
        <ul className="paragraph-2">
          <li>
            Access to the Site by Creators (including viewing statistics,
            discussions and matching with Products and Customers);
          </li>
          <li>Sending Products and/or related benefits.</li>
        </ul>
        <p>
          The services offered by Skeepers are offered to Creators free of
          charge.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">4. Access to Services</p>
        <p>
          Skeepers does not guarantee that the Site will be continuously
          accessible. Skeepers reserves the right to modify, suspend and/or
          delete all or part of the Site and the information it contains at any
          time and without notice. Consequently, Skeepers cannot be held liable
          for any proven or alleged damage, suffered directly or indirectly, by
          any Creator, related to the connection, consultation and/or use of the
          information provided by the Site.
        </p>
        <p>
          To access the Services, Creators must connect to the Site with their
          Identifiers under the conditions described below.
        </p>
        <p>
          In general, any breach of the stipulations of these T&Cs may result,
          immediately and without prior notice, in the deletion or suspension of
          the Creator's account, notwithstanding any claim for damages from
          Skeepers.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">5. Skeepers personal account</p>
        <p className="tc-neutral900 ml-16">1/ Registration</p>
        <p>
          Registration on the Site to create a personal account is done via the
          interface dedicated to Creators on the Site, by completing all the
          information identified as mandatory. The Creator can also complete
          optional information, such as, without this list being exhaustive: his
          favorite brands, his interests, etc.
        </p>
        <p>
          Skeepers reserves the right to refuse any incomplete or non-compliant
          registration.
        </p>
        <p>The Creator warrants to Skeepers that: </p>
        <ul className="paragraph-2">
          <li>
            The Creator is at least thirteen (13) years old. If he has not
            reached the age of majority in his country of residence, he must
            obtain parental consent to create a personal account on the Site;
          </li>
          <li>
            The Creator is not a former or current employee of Skeepers nor does
            he work for a media agency or an advertising agency that is a
            partner of Skeepers;
          </li>
        </ul>
        <p>
          As an Influencer, the Creator must have at least one account on a
          Social Network which is available in public mode and which has a
          minimum number of followers (this is specified for each Social Network
          concerned on the Site after the registration); and this throughout the
          duration of his registration on the Site.
        </p>
        <p>
          Skeepers reserves the right, at any time and throughout the
          registration period, to verify that the Influencer's Social Network
          Account meets the criteria mentioned above. In the event that the
          Social Network Account no longer fulfills the criteria mentioned
          above, Skeepers reserves the right to deactivate and/or terminate the
          Creator's personal account on the Site.
        </p>
        <p>
          The Creator agrees not to artificially increase, either automatically
          and/or manually, by himself or through a third party, the number of
          views, impressions and/or clicks associated with the Content that he
          publishes on his Social Network Account, nor to encourage others to do
          so.
        </p>
        <p>
          The Creator guarantees that the information provided for the creation
          of his account is accurate, sincere and personal. The Creator
          undertakes to regularly update his information in order to inform
          Skeepers about his personal profile and to benefit from the most
          suitable Services made available by Skeepers. Skeepers reserves the
          right to delete any account for which, in particular, the information
          is incorrect or whose address, in particular a postal address, would
          not allow the normal dispatch and use of the Products. The Creator's
          registration automatically leads to the creation of an account and a
          profile in the name of the nickname he uses on social networks, as
          well as an information space relating to the Creator accessible in
          particular to Customers in the case of matching.
        </p>

        <p className="tc-neutral900 ml-16">2/ The personal account </p>
        <p>
          After registering on the Site as described above, the Creator
          finalizes the creation of his account by entering the Identifiers,
          which are likely to be modified by the Creator, on his account. The
          account is accessible under the same conditions as the Site.
          Identifiers are personal and cannot, under penalty of having the
          account suspended or deleted, be communicated to or used by a third
          party. Any suspicion of disclosure, whether intentional or not, of
          identifiers and passwords engages the sole and personal responsibility
          of the Creator. In no event shall Skeepers be liable for any illicit
          or fraudulent use of Creatornames and passwords as well as of the
          various tools made available to the Creator.
        </p>
        <p>
          The Creator can also view on his account his credits, ordered and in
          progress Products, and ongoing and previous Content.
        </p>
        <p>
          The creation of a personal account does not automatically entitle the
          Creator to benefit from all the Services and does not guarantee
          "matching" with Products, Skeepers reserving the choice of the Testers
          who are beneficiaries of the Products, and the Customer that of the
          Beneficiary Influencers of the Products.
        </p>
        <p>
          The Creator may ask Skeepers to terminate their account at any time by
          giving written notice (email being sufficient) of fifteen (15) days
          sent to Skeepers.
        </p>

        <p className="tc-neutral900 ml-16">3/ The Profile</p>
        <p>
          The creation of the Skeepers' account on the Site generates the
          creation of a Profile making it possible for the Creator to be
          identified and allow him to benefit from the Services. As soon as the
          Personal Profile is created, the Creator is identified on the Site by
          the pseudonym and the avatar that he uses on the social network(s)
          entered by the Creator on the Site. The Profile also contains previous
          Content automatically uploaded to the Site, to which the Creator
          consents.
        </p>
        <p>
          According to the information provided by the Creator when registering,
          his Profile is likely to correspond to Products. In such an
          eventuality, a match between the Creator and the Products is then
          possible. However, Skeepers reserves the right to limit this matching
          according to its own selection criteria.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">6.  Use of the Services</p>
        <p className="tc-neutral900 ml-16">
          1/ Product Orders and Content Publication
        </p>
        <p>
          In his account, the Creator can view the Products offered by Customers
          likely to "match" with his Profile. Information relating to the price
          of the Products and the conditions to be complied with to disseminate
          Content relating thereto (for example, without this list being
          exhaustive: mention the Customer, add a hashtag, etc.) are also
          specified by the Customer when describing the Products.
        </p>
        <p>
          If an offer appeals to the Creator, he can select the "Order" tab to
          receive the Product. Before confirming the order, he must check a box
          to specify that he has read the conditions relating to the Content
          that he will have to publish.
        </p>
        <p>
          After confirming the order, the Creator receives the Product free of
          charge (either directly from the Customer or from Skeepers).
        </p>
        <p>
          Once the Product has been received and tested, the Creator creates
          Content while respecting the conditions set by the Customer in the
          Product description, which he has accepted.
        </p>
        <p>
          The Influencer shares the link of his Content on the Site within one
          hour of the publication of his Content on his Social Networks. The
          Content must be published in "public mode" and must remain accessible
          for at least thirty (30) days from its publication on his Social
          Networks, except in the event of a change of mind concerning the
          Product, which must first be notified by email to Skeepers.
        </p>
        <p>
          The Creator then checks a box to accept the Transfer of Rights
          Agreement ("Skeepers Community Agreement").
        </p>
        <p>
          Skeepers reserves the right to check the Content when the Creator
          publishes it on the Site in order to verify its compliance with the
          conditions set by the Customer, on the one hand, and with the Skeepers
          T&Cs and the Transfer of Rights Contract on the other hand.
        </p>
        <p>
          In the event that the Content is not compliant, it may not be
          broadcast on the Site. Furthermore, Skeepers may (i) notify the
          Creator of this non-compliance, and request that the necessary changes
          be made so that the Content complies with the conditions set by the
          Customer, the Skeepers' T&Cs and the Transfer of Rights Contract,
          and/or (ii) deactivate and/or terminate the Creator's account.
        </p>
        <p>
          With regards to written Tester reviews, the Tester writes their
          Content on the Site then, once validated by Skeepers, the Creator
          copies the Content onto the Customer's site within one hour of the
          validation.
        </p>

        <p className="tc-neutral900 ml-16">2/ Customer's Image and Products</p>
        <p>
          The consideration for the Services and, in particular, for receipt of
          the Products, is the obligation for the Creator to publish Content,
          which complies with the conditions set by the Customer and which he
          has accepted. Failing this, Skeepers reserves the right to limit or
          suspend access to its Services or to delete the Identifiers.
        </p>
        <p>
          The Creator undertakes to respect the Products and the Customer's
          brand image. Thus, the Creator undertakes, in all circumstances, to:
        </p>
        <ul className="paragraph-2">
          <li>
            Respect the laws and regulations in force applicable to Customers
            and Products and not to infringe the rights of third parties or
            public order;
          </li>
          <li>
            Not to resell or profit, in any way whatsoever, from the Products
            obtained, for a minimum period of 2 years from receipt or access to
            the Product;
          </li>
          <li>
            Not to receive any sum of money and/or other consideration for
            evaluating the Products (unless otherwise stated by Skeepers) and
            not to contact Customers other than to evaluate their Products as
            provided herein;
          </li>
          <li>
            Act, communicate, express themselves and write in relation to the
            Customer and/or the Products with discernment, courtesy, and respect
            for others in the comments, assessments, or exchanges that they may
            write and which will be broadcast on social networks ;
          </li>
          <li>
            Collaborate with Skeepers by providing it with all the information
            necessary for the proper performance of the Services;
          </li>
          <li>
            Respect the conditions set forth by the Customer in the description
            of the Product on the Site;
          </li>
          <li>
            To indicate that this is content in partnership with a brand, as
            soon as the Content or the relationship with the Customer falls
            within the criteria of digital advertising or commercial
            communication as defined by the ARPP.
          </li>
        </ul>
        <p>
          Consequently, the Creator thus refrains from broadcasting, in
          particular, and without this list being exhaustive:
        </p>
        <ul className="paragraph-2">
          <li>
            Content that is pornographic, obscene, indecent, shocking or
            unsuitable for a family audience, defamatory, abusive, violent,
            racist, xenophobic or revisionist,
          </li>
          <li>Infringing Content,</li>
          <li>Content that is harmful to the image of a third party</li>
          <li>
            Content that is false, misleading or that proposes or promotes
            illicit, fraudulent or misleading activities, Content that is
            harmful to the computer systems of third parties (such as viruses,
            worms, Trojan horses, etc.), and
          </li>
          <li>
            More generally, Content likely to infringe on the rights of third
            parties, to be prejudicial to third parties, or to engage the
            liability of Skeepers or the Customer in any way and in any form
            whatsoever. To this end, the Creator undertakes in particular not to
            mention or represent any brand, logo, including on clothing, other
            than the brand(s) of the Product(s) sent by the Customer. Similarly,
            the Creator agrees to use only royalty-free music in his Content.
            The Creator also undertakes not to include or show children who are
            not his own; or any adult who does not know or does not consent to
            the video being posted;
          </li>
        </ul>
        <p>
          When the Content or the relationship with the Customer falls within
          the criteria of digital advertising or commercial communication as
          defined by the ARPP, or when the Customer so requires, the Creator
          must include within each piece of Content, a clear and unequivocal
          notice that he has received the Products evaluated free of charge from
          the Customer via Skeepers, including either:
        </p>
        <ul className="paragraph-2">
          <li>
            On YouTube:
            <ul className="paragraph-2">
              <li>
                At the start of the video: an oral discourse that is easily
                audible and understandable for the Creator - in particular that
                is slow enough, and with words that will be understood by the
                audience. If the video lasts more than ten minutes, the Creator
                must repeat the speech at the end of the video;
              </li>
              <li>
                In the "About" section: a clear and unambiguous explanatory
                text.
              </li>
            </ul>
          </li>
          <li>
            On Instagram:
            <ul className="paragraph-2">
              <li>
                If the Content is a photo: a clear and unambiguous text provided
                in the first three lines of the photo description.
              </li>
              <li>
                If the Content is a story: a clear and unambiguous hashtag
                broadcast in each story.
              </li>
            </ul>
          </li>
          <li>
            On the Customer's website: a clear and unambiguous text provided in
            the first three lines of the Creator's comment relating to the
            Customer's product.
          </li>
          <li>
            The Content must reflect the honest opinion and personal experience
            of the Creator, based on his actual use of the Product. The Creator
            undertakes to inform Skeepers immediately if his opinion of this
            Product changes, and to remove the corresponding Content
            immediately.
          </li>
          <li>
            The Creator undertakes not to make any scientific or performance
            claims concerning the Product (such as "it reduces wrinkles! " or
            "It keeps me hydrated all day! "). The Creator must focus on what he
            likes or dislikes about the Product, from his personal point of
            view.
          </li>
        </ul>
        <p>
          Any breach of the stipulations of this article and, more generally, of
          these T&Cs may lead, immediately and without prior notice, to the
          deletion or suspension of the Creator's account, notwithstanding any
          claim for damages from Skeepers.
        </p>
        <p>
          In addition, Skeepers and/or the Customer may also ask the Creator to
          withdraw the Content in question in the event of non-compliance with
          the rules and principles set out above, which he undertakes to do
          without delay upon receiving the request.
        </p>
        <p>
          Any Product received is strictly reserved for the personal use of the
          Creator. The Creator is prohibited from selling it. The Creator may
          give and/or offer the Product to a third party only after having
          tested them and having published Content that complies with these T&Cs
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">
          7. Assignment of the rights to use the Content and authorization of
          image rights
        </p>
        <p>
          The publication of the Content on the Site by the Creator will
          concomitantly carry the conclusion by the Creator and Skeepers of a
          Contract of transfer of rights on the Content ("Skeepers Community
          Agreement") created by the Creator as well as the transfer of his
          image rights accessible from the following link:{' '}
          <a
            href="https://app.im.skeepers.io/community-agreement"
            target="_blank"
            rel="noopener noreferrer"
          >
            app.im.skeepers.io/community-agreement
          </a>
        </p>
        <p>
          In the event of the Creator's refusal to sign said Transfer of Rights
          Agreement, the latter may not publish their Content and must therefore
          return the Product received to the sender.
        </p>
        <p>
          The customer review written by the Creator is similar to a
          testimonial, always relating to a Tester experience and is purely for
          the information of future Testers. Thus, Skeepers and its partners may
          freely use, reproduce, publish, make available and translate the
          content of customer reviews worldwide and in any media and any medium
          whatsoever.
        </p>
        <p>
          The Creator shall not, on the day of acceptance of these T&Cs, see any
          reluctance or reservation to the provisions of this article. He
          expressly acknowledges that, if he is not prepared to sign the
          Contract for the transfer of rights, he will refrain from ordering a
          Product on the Site because the absence of the transfer of
          intellectual property rights and image rights attached to the Content
          would constitute a waste of time for Skeepers.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">8. Content Download</p>
        <p>
          The Customer may download the relevant Content on a non-exclusive
          basis in order to reproduce it, represent it and sub-license it, and
          in particular include it on any medium. The Customer also benefits
          from the authorization to use the images of the people represented in
          this Content identified by the Customer at the time of his request.
          The aforementioned rights are assigned by the Creator to Skeepers via
          the aforementioned Transfer of Rights Contract. Skeepers grants these
          rights to the Customer by granting a non-exclusive licence.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">9. Guarantee</p>
        <p>
          The Creator declares and guarantees that he holds the Contents
          (including the rights attached to them, including image rights) in
          full ownership and/or that the Creator has all the rights and
          authorizations necessary for the exploitation and distribution of the
          Content and that there is no agreement or any right that could be an
          obstacle to the present guarantee, the transfer or the authorization
          of the use of the image and the Contents.
        </p>
        <p>
          In cases where the commercial use of images of children under the age
          of thirteen on online platforms and its subsequent implementing
          decrees are applicable, the legal representatives of minor children
          under the age of thirteen are required to request the necessary
          approval from the competent administrative authority. Skeepers is
          exempt from all liability in the event of failure to obtain said
          approval by the legal representative(s). The Customer may, at any
          time, ask to verify the authorization issued to the legal
          representatives who should then communicate to them on first request.
          In this respect, the formalities to be observed are detailed on the
          official website of the French administration.
        </p>
        <p>
          The Creator also guarantees that this Content does not infringe on
          public order, good morals or the rights of third parties, does not
          infringe on any legislative or regulatory provision and, more
          generally, is in no way likely to involve the civil or criminal
          liability of Skeepers or the Customer.
        </p>
        <p>
          As a result of the foregoing, the Creator guarantees Skeepers and the
          Customer against any action, complaint, claim, eviction whatsoever, on
          the part of any person invoking non-compliance with the applicable
          regulations, an intellectual property right, to which the Content
          would infringe, or would have infringed, an act of unfair and/or
          parasitic competition, infringement of public order, morality or the
          rights of third parties and in particular tending to prohibit or
          restrict their use and will accordingly indemnify Skeepers and the
          Customer against all the consequences that could result from a breach
          of this guarantee (in particular, all losses, damages, expenses and/or
          costs including, in particular, legal costs and lawyers' fees).
        </p>
        <p>
          Skeepers does not monitor the Site but reserves the right to remove
          any Content that violates the T&Cs or that does not comply with
          applicable law, including that which violates an intellectual property
          right, as soon as Skeepers becomes aware of the illegality of said
          Content. To this end, each Creator will contact Skeepers if he
          considers that any Content violates one of his rights and/or the
          applicable law and according to the formalities imposed by law
          concerning requests for removal of illegal content. Upon receipt of a
          valid takedown request under applicable law, Skeepers will promptly
          remove the Content affected by such request from the Site.
        </p>
        <p>
          The Creator must evaluate and bear the risks associated with the use
          of any Content, in particular concerning the accuracy, completeness or
          usefulness of such Content.
        </p>
        <p>
          The Creator acknowledges and agrees that any questions, comments,
          suggestions, ideas, impressions or other information about the
          Services (hereinafter the "Proposals"), which the Creator provides to
          Skeepers, are not confidential and that Skeepers is entitled to use
          and distribute, without restriction, these Proposals, for any purpose,
          whether commercial or otherwise, without any recognition or
          compensation whatsoever being due to the Creator.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">10. Data Processing</p>
        <p>
          As part of its activities and the provision of the Services, Skeepers
          processes Creators' personal data as these terms are defined by the
          applicable regulations. The various processing operations carried out
          as well as the rights of Creators are described in Skeepers' privacy
          policy accessible on its site from the following link:{' '}
          <a
            href="https://app.im.skeepers.io/privacy?local=en-us"
            target="_blank"
            rel="noopener noreferrer"
          >
            app.im.skeepers.io/privacy?local=en-us
          </a>
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">11. Cookies</p>
        <p>
          When consulting the Site, cookies may be placed on the Creator's
          computer, mobile or tablet. The use of certain cookies requires the
          prior consent of the Creator. The Creator will find information
          specific to the cookies used on this site by clicking here{' '}
          <a
            href="https://app.im.skeepers.io?local=en-us"
            target="_blank"
            rel="noopener noreferrer"
          >
            app.im.skeepers.io/privacy?local=en-us
          </a>
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">
          12. Intellectual property of the elements of the Site
        </p>
        <p>
          All the elements published on the Site such as sounds, images,
          photographs, videos, writings, animations, programs, graphic charter,
          utilities, databases, software and other technologies are protected by
          the provisions of the Intellectual Property Code, are owned by
          Skeepers or are the subject of a license granted to Skeepers. Any
          distinctive sign appearing on the Site, in particular, company names,
          brands and logotypes are trademarks owned by Skeepers or by third
          parties or partners, in particular Customers whose offers are
          presented on the Site. Any total or partial reproduction, modification
          or use of these trademarks, illustrations, images and logos, for any
          reason and on any medium whatsoever, without the express and prior
          agreement of the owner of the rights is strictly prohibited and would
          constitute an infringement punishable by the Intellectual Property
          Code. The Creator undertakes to use the Site and its content in a
          strictly private setting. Use for commercial purposes is strictly
          prohibited. The Creator requests the prior authorization of Skeepers
          for any reproduction, publication, or copy of the various content.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">13. References and links</p>
        <p>
          Hypertext links are made available to the Creator referring to partner
          sites or third-party sites. Insofar as Skeepers cannot control these
          sites, Skeepers assumes no responsibility for the information
          contained on these sites. Skeepers cannot be held responsible, in
          particular, for modifications or updates to these sites or for any
          malfunction of them. Skeepers cannot under any circumstances be held
          liable for direct or indirect damage related to browsing or
          downloading from hypertext links published on the Website.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">14. Liability</p>
        <p>
          Use of the Site implies knowledge and acceptance by the Creator of the
          characteristics and limits of the Internet and the technologies
          associated with it. Skeepers cannot be held responsible for any damage
          whatsoever resulting from a connection to the Site that the Creator
          makes under his sole responsibility. As such, Skeepers declines all
          responsibility, in particular in the event of misuse or incident
          related to the use of the device to connect to the Site, to access the
          Internet, the maintenance or malfunction of the servers, the telephone
          line or any other technical connection, and the sending of forms to an
          incorrect or incomplete address, any computer errors or defects
          observed on the Site. Furthermore, Skeepers strives to provide
          accurate and up-to-date information on the site. However, Skeepers
          cannot in any way be held responsible for any inaccuracies or
          omissions on its Site.
        </p>
        <p>
          Skeepers will only be liable for direct damage resulting from the use
          of the Site and in any event, access to the Services being free, its
          liability is capped at the sum of €100. Consequently, Skeepers
          declines all responsibility and cannot be held liable for any indirect
          damage whatsoever, arising from a cause external to its Site, such as,
          without the list being exhaustive: arising from the use or receipt of
          a Product by the Creator, originating from or relating to Content
          created by the Creator, originating from or relating to the connection
          between the Customer and the Creator, etc.
        </p>
        <p>
          Skeepers reminds Creators that they may have fiscal (VAT, taxes etc.)
          and social (URSSAF, etc.) obligations relating to their activities for
          which they are fully responsible. The steps to be taken to comply with
          the legislative and regulatory requirements in this respect, which
          depend on different criteria depending on the particular case of the
          Creator.
        </p>
        <p>
          In addition to the warranties provided herein, the Creator provides a
          guarantee for Skeepers against any complaints, demands, actions and/or
          claims whatsoever that Skeepers may suffer as a result of the breach
          by the Creator of any of its obligations or warranties under these
          terms and conditions. He undertakes to indemnify Skeepers for any
          prejudice it may suffer and to pay it all the costs, charges and/or
          judgments it may have to bear as a result.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">
          15. Acceptance of the Terms of Use for Social Media
        </p>
        <p>
          Skeepers uses the YouTube API, in particular to authenticate and link
          the Creator's YouTube channel to their profile on the Site.
          Consequently, by using the Site, the Creator expressly accepts
          YouTube's terms of use available at the following URL:{' '}
          <a
            href="https://www.youtube.com/t/terms"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.youtube.com/t/terms
          </a>
        </p>
        <p>
          Likewise, the Creator undertakes to accept and comply with the terms
          of use of each Social Network that he uses to publish Content.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">16. Miscellaneous Provisions</p>
        <p>
          Skeepers reserves the right to modify these T&Cs at any time. A
          message in the form of a pop-up on the Site will inform Creators of
          the update of the T&Cs. It is recommended that the Creator reads the
          T&Cs regularly.
        </p>
        <p>
          The invalidity of all or part of one of the provisions of these T&Cs
          cannot result in the invalidity of the other provisions.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">17. Membership</p>
        <p>
          Acceptance of these general terms and conditions is realized by means
          of a checkbox on the registration form offered to the Creator when
          registering on the Site with a URL link to the T&Cs. This acceptance
          is without reservation. In addition, the T&Cs are available at any
          time on the Site.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">18. Applicable law</p>
        <p>
          The Site and the T&Cs are subject to New-York State law. Any dispute
          relating to the interpretation or execution of these Terms and
          Conditions will be subject to the jurisdiction of the competent courts
          of New-York.
        </p>
      </div>
    </>
  )
}

export default ConditionsForContributorsEN
